import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import WhiteLogo from "../images/ud_logo_white.svg"
import { ChevronRight } from "@material-ui/icons"
import Language from "./language"

const HeaderContainer = styled.header`
  background: var(--ud-blue);
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;
  min-width: 1200px;
  > div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    padding: 10px 0 10px 40px;
    div {
      color: white;
      font-size: 16px;
      font-weight: 400;
      text-decoration: none;
      span {
        line-height: 16px;
        display: block;
      }
    }
    img {
      margin-right: 5px;
      padding-bottom: 5px;
    }
    .chevron {
      margin: 0 15px 0 20px;
    }
    .logo {
      margin: 0 5px;
    }
  }

  @media screen and (max-width: 415px) {
    min-width: 414px;
    > div {
      padding-left: 0px;
      .chevron {
        display: none;
      }
      .hideInMobile {
        display: none;
      }
    }
  }
`
const HelpLink = styled(Link)`
  font-size: 14px;
  line-height: 16px;
  color: white;
  text-decoration: none;
  padding: 12px 22px;
  font-weight: 400;
  background: var(--ud-green);
  position: absolute;
  height: 40px;
  right: 0;
  top: 0;
`

// const Icon = styled.img`
//   vertical-align: text-top;
//   margin: 0 5px;
//   @media screen and (min-width: 415px) {
//     margin-left: 10px;
//   }
// `

// const LanguageButton = styled(Link)`
//   font-size: 12px;
//   line-height: 14px;
//   color: white;
//   text-decoration: none;
//   margin: 7px;
//   padding: 6px 15px;
//   font-weight: 400;
//   background: var(--ud-green);
//   position: absolute;
//   border-radius: 20px;
//   right: 85px;
//   top: 0;
// `

const Header = ({ location }) => {
  const { t } = useTranslation();
  const env = process.env.SERVICE_NAME;
  let serviceName = '';
  switch (env) {
    case 'cdn':
      serviceName = 'CDN';
      break;
    case 'opencloud':
      serviceName = 'Opencloud';
      break;
    default:
      break;
  };

  return (
    <HeaderContainer>
      <div>
        <WhiteLogo className="logo" />
        <div className="login">
          <span>{t("Control Panel")}</span>
        </div>
        <ChevronRight
          className="chevron"
          style={{ color: "white", fontSize: "19px" }}
        />
        <div className="hideInMobile">{serviceName}</div>
      </div>
      <HelpLink to="/">{t("HELP")}</HelpLink>
      <Language location={location} />
    </HeaderContainer>
  )
}

export default Header
